import { render, staticRenderFns } from "./ChangePasswordCard.htm?vue&type=template&id=643482cf&scoped=true&"
import script from "./ChangePasswordCard.js?vue&type=script&lang=js&"
export * from "./ChangePasswordCard.js?vue&type=script&lang=js&"
import style0 from "./ChangePasswordCard.scss?vue&type=style&index=0&id=643482cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643482cf",
  null
  
)

export default component.exports